import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { updateCriteria } from '@application/redux/scoreCard/score-card-slice';
import { Box } from '@mui/material';
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
const TimeRangePicker = ({ fieldValues, cardId, disabled = false }) => {
    const [startTime, setStartTime] = useState(null);
    const [endTime, setEndTime] = useState(null);
    const [isEndEnabled, setIsEndEnabled] = useState(false);
    const dispatch = useDispatch();
    useEffect(() => {
        if (fieldValues?.fieldValue && fieldValues.fieldValue.includes('-')) {
            const [start, end] = fieldValues.fieldValue.split(' - ').map((time) => time.trim());
            const parsedStart = dayjs(start, 'HH:mm');
            const parsedEnd = dayjs(end, 'HH:mm');
            if (parsedStart.isValid()) {
                setStartTime(parsedStart);
                setIsEndEnabled(true);
            }
            if (parsedEnd.isValid()) {
                setEndTime(parsedEnd);
            }
        }
    }, [fieldValues?.fieldValue]);
    const formatTime = (time) => time.format('HH:mm');
    const handleStartTimeChange = (newValue) => {
        setStartTime(newValue);
        setEndTime(null);
        if (newValue) {
            setIsEndEnabled(true);
        }
    };
    const handleEndTimeChange = (newValue) => {
        setEndTime(newValue);
    };
    const handleEndTimeBlur = () => {
        if (startTime && endTime) {
            const startMinutes = startTime.hour() * 60 + startTime.minute();
            const endMinutes = endTime.hour() * 60 + endTime.minute();
            if (endMinutes <= startMinutes) {
                toast.error('End time must be greater than start time');
                return;
            }
            const formattedRange = `${formatTime(startTime)} - ${formatTime(endTime)}`;
            try {
                const payload = {
                    id: fieldValues?.id,
                    assetId: '86AAC17D-397E-404F-9242-C4F1F2052B34',
                    cardId,
                    filedValue: formattedRange
                };
                dispatch(updateCriteria(payload))
                    .unwrap()
                    .then((res) => {
                    toast.success(res.message);
                })
                    .catch((err) => {
                    toast.error(err.message);
                });
            }
            catch (error) { }
        }
    };
    return (_jsx(LocalizationProvider, { dateAdapter: AdapterDayjs, children: _jsxs(Box, { sx: { display: 'flex', gap: 1, alignItems: 'center' }, children: [_jsx(TimePicker, { views: ['hours', 'minutes'], value: startTime, onChange: handleStartTimeChange, disabled: disabled, format: 'HH:mm', ampm: false, slotProps: {
                        textField: {
                            size: 'small',
                            fullWidth: true,
                            sx: { maxWidth: 114 }
                        }
                    } }), "-", _jsx(TimePicker, { views: ['hours', 'minutes'], value: endTime, onChange: handleEndTimeChange, disabled: disabled || !isEndEnabled, onAccept: handleEndTimeBlur, format: 'HH:mm', ampm: false, slotProps: {
                        textField: {
                            size: 'small',
                            fullWidth: true,
                            sx: { maxWidth: 114 }
                        }
                    } })] }) }));
};
export default TimeRangePicker;
